import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number", 
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_objectId",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};

const contexts = {
    CONTACT: "contact",
    CONVERSATION: "conversation",
    BLOCK: "block",
    EVENT: "event",
    WEBHOOK: "webhook",
    SYSTEM: "system",
    CUSTOM: "custom",
};

const defaultOperators = {
    string: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
    ],
    array: ["equal", "not_equal", "contains", "not_contains", "empty", "not_empty"],
    number: ["equal", "not_equal", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"],
    boolean: ["equal", "not_equal", "empty", "not_empty"],
    date: [
        "equal",
        "not_equal",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
        "empty",
        "not_empty",
    ],
    ObjectId: ["equal", "not_equal", "empty", "not_empty"],
    object: ["equal", "not_equal", "empty", "not_empty"],
    mixed: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
    ],
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        name,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || defaultOperators[valueType] || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class AppStoreModuleAttributeFactory {
    /**
     * @param parent {AutomationAttributesGenerator}
     */
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.reviewReceived()
        );
    }

    reviewReceived() {
        const e = AutomationEventTypes.APP_STORE.REVIEW_RECEIVED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "App Store Review Received", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}._id`, "Review Record ID", vt.STRING),
                ga(context, `${prefix}.reviewId`, "Review ID", vt.STRING),
                ga(context, `${prefix}.appId`, "App ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Channel ID", vt.STRING),
                ga(context, `${prefix}.rating`, "Rating", vt.NUMBER),
                ga(context, `${prefix}.title`, "Title", vt.STRING),
                ga(context, `${prefix}.body`, "Body", vt.STRING),
                ga(context, `${prefix}.reviewerNickname`, "Reviewer Nickname", vt.STRING),
                ga(context, `${prefix}.createdDate`, "Created Date", vt.DATETIME),
                ga(context, `${prefix}.territory`, "Territory", vt.STRING),
                ga(context, `${prefix}.status`, "Status", vt.STRING),
                ga(context, `${prefix}.response`, "Response Info", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.response.id`, "Response ID", vt.STRING),
                    ga(context, `${prefix}.response.body`, "Response Body", vt.STRING),
                    ga(context, `${prefix}.response.state`, "Response State", vt.STRING),
                    ga(context, `${prefix}.response.lastModifiedDate`, "Response Last Modified", vt.DATETIME),
                ]),
                ga(context, `${prefix}.app`, "App Info", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.app._id`, "App Record ID", vt.STRING),
                    ga(context, `${prefix}.app.appId`, "App ID", vt.STRING),
                    ga(context, `${prefix}.app.bundleId`, "Bundle ID", vt.STRING),
                    ga(context, `${prefix}.app.name`, "App Name", vt.STRING),
                    ga(context, `${prefix}.app.primaryLocale`, "Primary Locale", vt.STRING),
                    ga(context, `${prefix}.app.iconUrl`, "Icon URL", vt.STRING),
                    ga(context, `${prefix}.app.totalReviewCount`, "Total Review Count", vt.NUMBER),
                    ga(context, `${prefix}.app.averageRating`, "Average Rating", vt.NUMBER),
                ]),
            ])
        ];
    }
}

export default AppStoreModuleAttributeFactory;
